import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { listfilesanad } from '../../../services/user/user';
import FileCard from './FileCard'; // Component to render individual files
import { Box, CircularProgress, Container, Typography } from '@mui/material';
import Swal from 'sweetalert2';
import { motion } from 'framer-motion';
import { useTranslation } from "react-i18next";

export default function SanadDetail() {
  const { id } = useParams(); // Get the ID from the URL
  const navigate = useNavigate(); // For navigation
  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(true);
const {t} = useTranslation();
  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await listfilesanad(id);
        setFiles(response.data.value); // Set the files array with the URLs
      } catch (err) {
        Swal.fire({
          title: t("FileExpired.Title"),
          text: t("FileExpired.Text"),
          confirmButtonText:t("Progress.ok"),
        }).then(() => {
          navigate('/'); // Navigate to the homepage after the alert is closed
        });
      } finally {
        setLoading(false);
      }
    };

    fetchFiles();
  }, [id, navigate]);

  const getFileFormat = (fileUrl) => {
    return fileUrl.split('.').pop(); // Extract the file extension from the URL
  };

  if (loading)
    return (
      <Box sx={{ height: '50vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress color="primary" size={70} />
      </Box>
    );

  return (
    <Container sx={{ padding: '1rem 2rem' }}>
      <Typography variant="h3" sx={{ fontWeight: '400' }}>
      {(t("fileCard.fileNum"))} {files.length}
      </Typography>
      <div className="file-card-container">
  {files.map((fileUrl, index) => (
    <motion.div
      key={index}
      initial={{ opacity: 0, y: 20 }}           // Initial animation: fade in + slide from bottom
      animate={{ opacity: 1, y: 0 }}            // Mount animation: fade in + slide to position
      exit={{ opacity: 0, y: -20 }}             // Exit animation: fade out + slide up
      transition={{
        duration: 0.5,                          // Duration for enter animation
        delay: 0.1 * index,                      // Delay for staggered effect
      }}
    >
      <FileCard
        key={index}
        imageUrl={fileUrl}
        format={getFileFormat(fileUrl)}
        index={index + 1}
      />
    </motion.div>
  ))}
</div>
    </Container>
  );
}
 